import { render } from "./UploadEvmsSheet.vue?vue&type=template&id=67e61dff"
import script from "./UploadEvmsSheet.vue?vue&type=script&lang=ts"
export * from "./UploadEvmsSheet.vue?vue&type=script&lang=ts"

import "./UploadEvmsSheet.vue?vue&type=style&index=0&id=67e61dff&lang=less"
script.render = render

export default script